import React from "react";
import {
  useStepData,
} from "components/StepForm";

export function Step4() {
  const [donateUnsoldItems, setDonateUnsoldItems] = useStepData<boolean>(
    "donateUnsoldItems",
    false
  );

  return (
    <div className="onboarding-steps">
      <h1 className="onboarding-step--title">Step 4</h1>
      <div className="onboarding-donate">
        <h4>Are you interested in donating?</h4>
        <div className="col-12">
          <input
            type="checkbox"
            id="cb1"
            onChange={(e) => setDonateUnsoldItems(e.target.checked)}
            checked={donateUnsoldItems}
          />
          <label htmlFor="cb1" className="p-checkbox-label cursor-pointer">
            Donate my items if they do not sell (Optional)
          </label>
        </div>
      </div>
    </div>
  );
}
